/* ============================================================
   data.js — scenario factory + geocoder
   ============================================================ */

export const SCENARIOS = {};

// Defaults for a project's slot-generation settings. Lives here so it can be
// shared by both createEmptyScenario and the App's pre-fill of the settings
// modal during the new-project flow.
export const DEFAULT_SETTINGS = {
  slotWidth: 2.5,
  slotLength: 5.0,
  defaultAngle: 90,
  defaultSide: 'right',
  laneWidthTwoWay: 6.0,
  laneWidthOneWay: 3.5,
  turningRadius: 6.5,
  accessiblePct: 3,
  accessibleWidth: 3.5,
  accessibleNearEntry: true,
  rowScheme: 'A1',
  showLabels: 'auto',
  markBackIn: false,
};

export function createEmptyScenario({ name, subtitle, address, lng, lat, zoom = 18, target = 0, settings }) {
  const id = 'sc-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e4).toString(36);
  return {
    id,
    name: name || 'Neuer Standort',
    subtitle: subtitle || '',
    address: address || '',
    center: [lng, lat],
    zoom,
    target,
    boundaries: [],
    rows: [],
    lanes: [],
    obstacles: [],
    entries: [],
    settings: { ...DEFAULT_SETTINGS, ...(settings || {}) },
  };
}

function shortenLabel(r) {
  const a = r.address || {};
  const street = [a.road, a.house_number].filter(Boolean).join(' ');
  const city   = a.city || a.town || a.village || a.municipality || a.suburb || a.county;
  const country= a.country_code ? a.country_code.toUpperCase() : '';
  return [street || r.name, city, country].filter(Boolean).join(' · ');
}

export async function geocodeAddress(query, { limit = 6, lang = 'de' } = {}) {
  const q = (query || '').trim();
  if (!q) return [];
  const url = 'https://nominatim.openstreetmap.org/search'
    + '?format=jsonv2'
    + '&addressdetails=1'
    + '&limit=' + encodeURIComponent(limit)
    + '&accept-language=' + encodeURIComponent(lang)
    + '&q=' + encodeURIComponent(q);
  const resp = await fetch(url, { headers: { 'Accept': 'application/json' } });
  if (!resp.ok) throw new Error('Geocoder unreachable (' + resp.status + ')');
  const json = await resp.json();
  return json.map((r) => ({
    label:    r.display_name,
    shortLabel: shortenLabel(r),
    lat:      parseFloat(r.lat),
    lng:      parseFloat(r.lon),
    type:     r.type,
    category: r.category,
    importance: r.importance,
    raw:      r,
  }));
}
